import React from 'react';

import styles from '~/components/back-to-top-pill/back-to-top-pill.module.scss';

// Passing scrollElRef as a prop allows the pill to be used in modals
const BackToTopPill = ({ scrollElRef }) => {
  return (
    <button
      className={styles.toTopPill}
      style={{
        top: scrollElRef ? '0rem' : 'revert-layer',
        position: scrollElRef ? 'sticky' : 'fixed',
      }}
      onClick={() =>
        (scrollElRef ? scrollElRef : window).scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      }
    >
      <p>Back to top</p>
      <img
        src="/icons/up-chevron-white.svg"
        alt="White arrow pointing up"
        width="8"
        height="4"
      />
    </button>
  );
};

export default BackToTopPill;
